import React, { useEffect, useState } from "react";
import TSGBg from "../tsg-bg";
import PaymentCard from "./cards";
import Button from "../button";
import CourseBanner from "../banner/course-banner";
import ToggleSwitch from "./baToogle";
import TechCourseBanner from "../techExperience/tech-course-banner";
import { techRegionPrice } from "../../data/techPayments";

const TechPayments = React.forwardRef(({
  setIsEnrolOpen, isEnrolOpen, showBanner, courseBanner, setShowBanner, selectedRegion = "US & Canada",
}, ref) => {
    const [showCourseBanner, setShowCourseBanner] = React.useState(true);
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(false);
  const [paymentOptionsWithSymbols, setPaymentOptionsWithSymbols] = useState([]);

  const handleToggle = (isOn) => {
    setIsFeatureEnabled(isOn);
  };  useEffect(() => {
    const userRegion = techRegionPrice[selectedRegion];
    if (userRegion && userRegion.payments) {
      const paymentOptions = userRegion.payments;
      let updatedPaymentOptions = [];
      
      // isFeatureEnabled indicates the toggle is ON
      // For Europe-Africa: when ON -> EUR, when OFF -> GBP
      // For US & Canada: when ON -> CAD, when OFF -> USD
      if (isFeatureEnabled) {
        // Toggle enabled (right side) - show Euro for Europe/Africa, CAD for US/Canada
        updatedPaymentOptions = paymentOptions.map((option) => {
          // Create a copy of the description for modification
          let updatedDescription = option.description;
          
          // Update descriptions to reflect the toggled currency
          if (selectedRegion === "Europe - Africa") {
            // Replace £ amounts with € amounts in descriptions
            updatedDescription = updatedDescription.replace(/£(\d+)/g, '€$1');
          } else {
            // Replace $ amounts with CAD amounts in descriptions
            updatedDescription = updatedDescription.replace(/\$(\d+)/g, 'CAD $1');
          }
          
          return {
            ...option,
            price: option.defaultPrice, // Use the alternate price (CAD/EUR)
            slashPrice: option.defaultSlash, // Use the alternate slash price
            symbol: selectedRegion === "Europe - Africa" ? "€" : "CAD",
            title: option.type, // Use the type field as title
            description: updatedDescription
          };
        });
      } else {
        // Toggle disabled (left side) - show Pounds for Europe/Africa, USD for US/Canada
        updatedPaymentOptions = paymentOptions.map((option) => ({
          ...option,
          price: option.price, // Use the standard price (USD/GBP)
          slashPrice: option.slashPrice, // Use the standard slash price
          symbol: selectedRegion === "Europe - Africa" ? "£" : "USD",
          title: option.type, // Use the type field as title
          description: option.description // Use original description
        }));
      }
      
      setPaymentOptionsWithSymbols(updatedPaymentOptions);
    }
  }, [isFeatureEnabled, selectedRegion]);

   // Hardcoded data for the course banner
   const courseBanners = {
    discount: "25",
    title: "New Project Starts in",
    message: "Note: Immediate team onboarding on payment",
    type: "Link",
    code: "EARLYBIRD30",
    btnUrl: "#payments",
    expandedOnMobile: true
  };

  return (
    <TSGBg bgStyle="slopeLeftLow">
      <div ref={ref} className="w-screen lg:w-[calc(100vw-24px)] mt-8 xl:w-[1200px] flex flex-col items-center gap-10 lg:gap-[45px]">
        <div className="flex flex-col items-center gap-4">          <h3 className="text-xl md:text-[28px] md:leading-9 text-[#1E1B2E] font-bold">
            Flexible and Affordable Pricing
          </h3> 

           <div className="w-full mb-6">
                  {showCourseBanner && (          <TechCourseBanner
                      discount={courseBanners.discount}
                      title={courseBanners.title}
          
                      message={courseBanners.message}
                      setShowBanner={setShowCourseBanner}
                      expandedOnMobile={courseBanners.expandedOnMobile}
                      scrollToPayments={() => {
                        // Use ref to scroll to payments section
                        if (ref && ref.current) {
                          ref.current.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                      btnLabel={null}
                      useCustomLayout={true}
                    />
                  )}
                </div>
                   {/* <Button size onClick={() => setIsEnrolOpen(true)}>Start week one for free</Button>        */}
             <div className="flex flex-col items-center gap-2">
            <p className="text-sm text-gray-600">
              {selectedRegion === "Europe - Africa" 
                ? `Toggle between GBP (£) and EUR (€)` 
                : `Toggle between USD ($) and CAD (CA$)`}
            </p><ToggleSwitch
              onColor="#F8D210"
              offColor="#ccc"
              isOnInitial={isFeatureEnabled}
              onToggle={handleToggle}
              payments={techRegionPrice[selectedRegion].payments}
              regionPrice={selectedRegion}
            />
          </div>
          {/* Region selection moved to parent component */}
        </div>
        {showBanner && (
          <CourseBanner
            showBanner={showBanner}
            setShowBanner={setShowBanner}
            {...courseBanner}
          />
        )}        <div className="flex flex-col lg:flex-row w-full max:h-[1050px] h-full gap-4 lg:gap-16 justify-between">
          {paymentOptionsWithSymbols.map((priceOption) => (
            <PaymentCard
              key={priceOption.id}
              card={{
                ...priceOption,
                price: priceOption.price,
                symbol: priceOption.symbol,
                slashPrice: priceOption.slashPrice,
                userRegion: techRegionPrice[selectedRegion],
                description: priceOption.description,
                pillText: priceOption.pillText,
                buttonLabel: priceOption.buttonLabel || "Enroll Now",
                buttonUrl: priceOption.buttonUrl
              }}
              href={priceOption.href}
              href2={priceOption.href2}
              href3={priceOption.href3}
              setIsEnrolOpen={setIsEnrolOpen}
              isEnrolOpen={isEnrolOpen}
            />
          ))}
        </div>
      </div>
    </TSGBg>
  );
});

export default TechPayments;
